import { Design } from '../types';
import { useSubject } from './useSubject';

/** Get the current @see Design that is loaded in the application. */
export function useDesign(): Design {
  const appManager = window.apm;
  return useSubject(
    appManager.serializedChangeSubject,
    appManager.serialized
  );
}
